<template>
  <span :class="['chip', 'chip--mini', 'chip--aligned-middle', typeClass]">
    <slot />
  </span>
</template>

<script>
const types = {
  SUCCESS: 'success',
  FAIL: 'fail',
  WARNING: 'warning',
};

export default {
  name: 'Badge',
  props: {
    type: {
      type: String,
      default: null,
      validator(value) {
        return !value || Object.values(types).includes(value);
      },
    },
  },
  computed: {
    typeClass() {
      if (this.type === types.SUCCESS) {
        return 'chip--success';
      }
      if (this.type === types.FAIL) {
        return 'chip--alert';
      }
      if (this.type === types.WARNING) {
        return 'chip--warning';
      }
      return null;
    },
  },
};
</script>
